module.exports = __webpack_public_path__ + "media/images/manifest/microbius-96-eb092e47e9adf8d6707a8953ea4e033e.png";